export const salesTrendColors = ['#2563eb', '#0d9488', '#9333ea', '#ea580c', '#db2777', '#4f46e5', '#64748b']
const salesTrendLinePatterns = ['', '10 5', '3 5', '12 4 3 4', '6 4', '16 6', '3 3 10 3']

export const normalizeSalesStatus = (status) => String(status ?? '').trim() || 'RECEIVED'

const dateKey = (value) => {
  const date = String(value ?? '')
  if (/^\d{8}$/.test(date)) return `${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6, 8)}`
  const match = date.match(/^(\d{2})\/(\d{2})\/(\d{4})$/)
  return match ? `${match[3]}-${match[1]}-${match[2]}` : date
}

export const buildSalesTrend = (rows = []) => {
  const daily = new Map()
  const statuses = new Set()
  for (const row of rows) {
    const date = dateKey(row.calcDate)
    if (!date) continue
    const status = normalizeSalesStatus(row.status)
    const numericAmount = Number(row.amount)
    const amount = Number.isFinite(numericAmount) ? numericAmount : 0
    if (!daily.has(date)) daily.set(date, new Map())
    const values = daily.get(date)
    values.set(status, (values.get(status) ?? 0) + amount)
    statuses.add(status)
  }
  const dates = [...daily.keys()].sort()
  const series = [...statuses].sort().map((name, index) => ({
    name,
    color: salesTrendColors[index % salesTrendColors.length],
    dashArray: salesTrendLinePatterns[index % salesTrendLinePatterns.length],
    values: dates.map((date) => daily.get(date).get(name) ?? 0),
  }))
  const totals = dates.map((date) => [...daily.get(date).values()].reduce((sum, value) => sum + value, 0))
  const total = totals.reduce((sum, value) => sum + value, 0)
  const peak = totals.length ? Math.max(...totals) : 0
  return { dates, series, total, average: dates.length ? total / dates.length : 0, peak, peakDate: dates[totals.indexOf(peak)] ?? '' }
}

export const buildTrendScale = (series, tickCount = 4) => {
  let min = 0
  let max = 0
  for (const item of series) {
    for (const value of item.values) {
      min = Math.min(min, value)
      max = Math.max(max, value)
    }
  }
  const range = max - min || 1
  const rawStep = range / tickCount
  const magnitude = 10 ** Math.floor(Math.log10(rawStep))
  const step = [1, 2, 5, 10].find((factor) => factor * magnitude >= rawStep) * magnitude
  const lower = Math.floor(min / step) * step
  const upper = Math.max(lower + step, Math.ceil(max / step) * step)
  const count = Math.round((upper - lower) / step)
  const ticks = Array.from({ length: count + 1 }, (_, index) => {
    if (index === 0) return lower
    if (index === count) return upper
    return Math.min(upper, Math.max(lower, Number((lower + index * step).toPrecision(12))))
  })
  return { min: lower, max: upper, ticks }
}
